import { clearAuthSession } from '../services/authSession';
import { clearShopCheckout } from '../shop/shopSession';
import { clearSelectedFavourite } from './selectedArt';
import { clearTicket } from './ticket';

/** Wipe signed-in user, scanned ticket, cart, and selected art for a fresh kiosk session. */
export function clearKioskSession() {
  clearSelectedFavourite();
  clearAuthSession();
  clearTicket({ all: true });
  clearShopCheckout();
}
